module.exports = "//public.zight.com/packs/media/images/video-trim-041fec8977ff741e77986bd6205bacb6.svg";